<template>
	<div>
		<div class="foot-tab" :class="{'!rounded-b-none' : noCorners}">
			<div class="foot-tab-head">
				<div class="foot-tab-row-label">
					<span class="cursor-pointer underline zt-hover whitespace-nowrap min-w-[18px] pl-[10px]"
                @click="sortAscending = sortAscending === 0 ? 1 : 0; isLpSet = !isLpSet">L.p</span>
					<span class="cursor-pointer underline zt-hover truncate"
					      :class="{ '!no-underline' : sortColumn === 'name' }"
					      @click="sortTable('name', $event)">{{getTitleString(phaseString)}}</span>
				</div>
				<div class="flex">
					<div class="foot-tab-row-item"
					     :class="{ '!no-underline' : sortColumn === 'matches' }"
					     @click="sortTable('matches', $event)">
						<div>M</div>
					</div>
					<div class="foot-tab-row-item"
					     :class="{ '!no-underline' : sortColumn === 'penalty+' }"
					     @click="sortTable('penalty+', $event)">
						<div>K+</div>
					</div>
					<div class="foot-tab-row-item"
					     :class="{ '!no-underline' : sortColumn === 'penalty-' }"
					     @click="sortTable('penalty-', $event)">
						<div>K-</div>
					</div>
					<div class="foot-tab-row-item !w-[50px]"
					     :class="{ '!no-underline' : sortColumn === 'bm' }"
					     @click="sortTable('bm', $event)">
						<div>ŚR</div>
					</div>
				</div>
			</div>
			<div class="foot-tab-row" :class="{ '!bg-zt-more/35' : selectedTeamsIds.includes(+team.team_id), '!border-b-0 !rounded-b-zt': index === leagueTable.length - 1 }"
			     v-for="(team, index) in leagueTable" :key="team.team_id">
				<div class="foot-tab-row-label" :class="{ '!bg-[#4d5a6d]' : selectedTeamsIds.includes(+team.team_id) }">
					<p class="flex items-center">
						<span class="inline-block w-[22px] !shrink-0">{{isLpSet ?  leagueTable.length - index : index + 1}}.</span>
            <a v-if="!selectedTeamsIds.includes(+team.team_id)"
               :href="team.clickable ? `/wyniki-pilka-nozna/druzyny/${team.query_name}/` : null"
               class="no-default-style" :class="{ 'zt-hover': team.clickable }">
              <span class="flex items-center mr-2 aspect-square h-5">
                <TeamImg :team="team"/>
              </span>
            </a>
            <span v-else class="flex items-center mr-2 aspect-square h-5">
              <TeamImg :team="team"/>
            </span>
						<a v-if="!selectedTeamsIds.includes(+team.team_id)"
               class="no-default-style text-ellipsis line-clamp-1 break-all" :class="{ 'zt-hover': team.clickable }"
               :href="team.clickable ? `/wyniki-pilka-nozna/druzyny/${team.query_name}/` : null">
              {{ team.short_name?.length > 0 ? team.short_name : team.name }}
            </a>
						<span v-else class="text-ellipsis line-clamp-1 break-all">
              {{ team.short_name?.length > 0 ? team.short_name : team.name }}
            </span>
					</p>
				</div>
        <Transition appear name="fade" mode="out-in">
          <div :key="filterKey" class="flex">
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'matches' }">
              <div>{{ allMatches(team) }}</div>
            </div>
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'penalty+' }">
              <div>{{ getTeamPenaltyStat(team, 'for') }}</div>
            </div>
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'penalty-' }">
              <div>{{ getTeamPenaltyStat(team, 'against') }}</div>
            </div>
            <div class="foot-tab-row-item !w-[50px]" :class="{ 'foot-tab-row-item-active' : sortColumn === 'bm' }">
              <div>{{ getAvgPenalty(team) }}</div>
            </div>
          </div>
        </Transition>
			</div>
		</div>
	</div>
</template>

<script>

import football_mixin from "../../mixins/football_mixin";
import TeamImg from "../football_stats/blocks/TeamImg.vue";

export default {
	name: 'PenaltyTable',
	components: {TeamImg},
	inject: ['WP'],
	mixins: [football_mixin],
	props: {
    noCorners: {
      type: Boolean,
      default: false
    },
    phase: {
      type: String,
      default: ''
    },
		teams: Array,
		filters: Array,
		details: Object,
		selectedTeamsIds: {
			type: Array,
			default: []
		},
		events: Array,
    view: {
      type: String,
      default: 'normal',
      validator: function (value) {
        return ['normal', 'compact'].includes(value);
      }
    }
	},
	data() {
		return {
			previousSortColumn: null,
			displayedTable: 'all',
			sortColumn: 'penalty+',
			sortAscending: 0,
			isLpSet: false,
			currentSubTab: this.filters[2] ?? 'all',
			penaltiesFor: 'dictatedfor',
			teamsSorted: [],
		}
	},
	mounted() {
		this.teamsSorted = this.teams;
		this.teamsSorted.forEach((team, i) => {
      team.currentTablePosition = i+1;
      team.penalties = {
        home: {
         for: this.penalties(team, 'dictatedfor', 'home'),
         against:  this.penalties(team, 'dictatedagainst', 'home')
        },
        away: {
          for: this.penalties(team, 'dictatedfor', 'away'),
          against:  this.penalties(team, 'dictatedagainst', 'away')
        }
      }
      team.allGoals = this.allGoals(team);
    });
    this.teamsSorted = this.teamsSorted.sort(this.sortTeams);
	},
	computed: {
    rowHeight() {
      return this.view === 'compact' ? '28px' : '38px';
    },
    legendBarHeight() {
      return this.view === 'compact' ? '19px' : '30px';
    },
    filterKey() {
      return this.filters.join('-') + `-${ this.view }`;
    },
    phaseString() {
      return this.phase.replace('_', ' ');
    },
		leagueTable() {
			if (this.teamsSorted && this.teamsSorted.length > 0 && this.events.length > 0) {
				return this.teamsSorted.slice().sort(this.sortTeams);
			}	else {
				return this.teamsSorted;
			}
		},
	},
	watch: {
		filters(newVal) {
			setTimeout(() => {
				this.currentSubTab = newVal[2];
				this.leagueTable.sort(this.sortTeams).forEach((team, i) => {team.currentTablePosition = i+1;});
			}, 250);
		}
	},
	methods: {
		penalties(team, penaltiesFor, matchDetail) {
			if (penaltiesFor === 'dictatedfor') {
        if (matchDetail === 'home') {
					let matches = this.getTeamMatches(team, matchDetail);
					return this.events.filter((event) => {
						let match = matches.find(m => m.match_id === event.match_id);
						return event.team_id === team.team_id && event.details === 'Penalty'
							&& match ? match.localteam_id === team.team_id : false;
					}).length;
				} else if (matchDetail === 'away') {
					let matches = this.getTeamMatches(team, matchDetail);
					return this.events.filter((event) => {
						let match = matches.find(m => m.match_id === event.match_id);
						return event.team_id === team.team_id && event.details === 'Penalty'
						&& match ? match.visitorteam_id === team.team_id : false;
					}).length;
				}
			} else if (penaltiesFor === 'dictatedagainst') {
				 if (matchDetail === 'home') {
					let matches = this.getTeamMatches(team, matchDetail);
					return this.events.filter((event) => {
						let match = matches.find(m => m.match_id === event.match_id);
						return event.team_id !== team.team_id && event.details === 'Penalty'
						&& match ? match.localteam_id === team.team_id: false;
					}).length;
				} else if (matchDetail === 'away') {
					let matches = this.getTeamMatches(team, matchDetail);
					return this.events.filter((event) => {
						let match = matches.find(m => m.match_id === event.match_id);
						return event.team_id !== team.team_id && event.details === 'Penalty'
						&& match ? match.visitorteam_id === team.team_id: false;
					}).length;
				}
			}
		},
		sortTeams(a, b) {
			let diff = 0;
			if (this.sortColumn === 'name') {
				if (this.sortAscending) {
					diff = a.name.localeCompare(b.name);
				} else {
					diff = b.name.localeCompare(a.name);
				}
				return diff;
			}
			switch (this.sortColumn) {
				case 'matches':
					if (this.sortAscending) {
						diff = this.allMatches(a) - this.allMatches(b);
					} else {
						diff = this.allMatches(b) - this.allMatches(a);
					}
					break;
				case 'penalty+':
					if (this.sortAscending) {
						diff = this.getTeamPenaltyStat(a, 'for') - this.getTeamPenaltyStat(b, 'for');
					} else {
						diff = this.getTeamPenaltyStat(b, 'for') - this.getTeamPenaltyStat(a, 'for');
					}
					break;
				case 'penalty-':
          if (this.sortAscending) {
            diff = this.getTeamPenaltyStat(a, 'against') - this.getTeamPenaltyStat(b, 'against');
          } else {
            diff = this.getTeamPenaltyStat(b, 'against') - this.getTeamPenaltyStat(a, 'against');
          }
					break;
				case 'bm':
				default:
					if (this.sortAscending) {
						diff = +this.allGoals(a).split(':')[0] - +this.allGoals(b).split(':')[0] || +this.allGoals(b).split(':')[1] - +this.allGoals(a).split(':')[1];
					} else {
						diff = +this.allGoals(b).split(':')[0] - +this.allGoals(a).split(':')[0] || +this.allGoals(a).split(':')[1] - +this.allGoals(b).split(':')[1];
					}
					break;
			}
			return diff;
		},
    getTeamPenaltyStat(team, penaltyDetail) {
     if (this.currentSubTab === 'all') {
      return penaltyDetail === 'for' ? team.penalties.home.for + team.penalties.away.for : team.penalties.home.against + team.penalties.away.against;
     } else if (this.currentSubTab === 'home') {
      return penaltyDetail === 'for' ? team.penalties.home.for : team.penalties.home.against;
     } else {
      return penaltyDetail === 'for' ? team.penalties.away.for : team.penalties.away.against;
     }
    },
    getAvgPenalty(team) {
      return ((this.getTeamPenaltyStat(team, 'for') + this.getTeamPenaltyStat(team, 'against'))
          / this.allMatches(team)).toFixed(1)
    }
	}
}

</script>

<style scoped>
.foot-tab-row-item {
  height: v-bind(rowHeight);
}

.foot-tab-row {
  height: v-bind(rowHeight);
}

.foot-tab-row-marked-red::before, .foot-tab-row-marked-red-variant::before,
.foot-tab-row-marked-blue::before, .foot-tab-row-marked-blue-variant::before,
.foot-tab-row-marked-purple::before, .foot-tab-row-marked-purple-variant::before,
.foot-tab-row-marked-green::before, .foot-tab-row-marked-green-variant::before {
  height: v-bind(legendBarHeight);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>